import React, { useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectSidebarCollapsed } from 'store/Settings';
import { PromotionSummary } from 'types/Project';
import SidebarComponent from './Sidebar';

function Sidebar( { promotionsSummary }:{ promotionsSummary:PromotionSummary[] } ) {
  const sidebarCollapsed = useSelector( selectSidebarCollapsed );

  useEffect( () => {
    if ( sidebarCollapsed ) document.body.classList.remove( 'sidebar-show' );
    else document.body.classList.add( 'sidebar-show' );
  }, [sidebarCollapsed] );

  return (
    <Collapse in={!sidebarCollapsed} dimension="width">
      <div className="d-none d-md-block">
        <SidebarComponent promotionsSummary={promotionsSummary} />
      </div>
    </Collapse>
  );
}

export default Sidebar;
